<mc-system-message-card *ngFor="let message of messages$ | async"
  [messageType]="message.Type"
  [title]="message.Title"
  [message]="message.Message"
  (cardClick)="onMessageClicked(message)"
  (closeClick)="onMessageClosed(message)">
</mc-system-message-card>
